<template>
  <v-text-field
    :label="label"
    :value="internalValue"
    @input="handleInput"
    @focus="onFocus"
    @blur="onBlur"
    @keydown="restrictInput"
    :disabled="disabled"
    :readonly="readonly"
    :rules="rules"
    :dense="dense"
    hide-details
    type="text"
    :class="['app-text-field app-input-bordered', { 'remove-top-spacing': removeTopSpacing }]"
    @paste.stop.prevent="onPaste($event)"
  />
</template>

<script>
import { sanitizePastedNumeric } from "@/helpers/numbers";

export default {
  name: "FormattedPercentageInput",
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    label: String,
    disabled: Boolean,
    readonly: Boolean,
    removeTopSpacing: Boolean,
    dense: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalValue: "",
      isFocused: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.updateInternal(val);
      },
    },
  },
  methods: {
    formatNumberSmart(num) {
      if (!isFinite(num)) return "";
      if (Number.isInteger(num)) {
        return num.toLocaleString("en-US", { maximumFractionDigits: 0 });
      }
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },

    onPaste(e) {
      const text = (e.clipboardData || window.clipboardData)?.getData("text") || "";
      const numStr = sanitizePastedNumeric(text, true);
      const num = parseFloat(numStr);
      this.$emit("input", Number.isNaN(num) ? null : num);
    },

    updateInternal(val) {
      const num = Number(val);
      if (val === null || val === undefined || val === "") {
        this.internalValue = "";
      } else if (isNaN(num)) {
        this.internalValue = "";
      } else {
        this.internalValue = this.isFocused ? `${num}` : `${this.formatNumberSmart(num)}%`;
      }
    },

    handleInput(val) {
      const clean = val.replace(/[^\d.]/g, "");
      const parts = clean.split(".");
      const safe = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join("")}` : clean;

      const num = parseFloat(safe);
      if (isNaN(num)) {
        this.internalValue = "";
        this.$emit("input", null);
        return;
      }

      let bounded = num;
      if (bounded > 100) bounded = 100;
      if (bounded < 0) bounded = 0;

      this.internalValue = safe;
      this.$emit("input", bounded);
    },

    onFocus() {
      this.isFocused = true;
      this.updateInternal(this.value);
    },
    onBlur() {
      this.isFocused = false;
      this.updateInternal(this.value);
    },

    restrictInput(event) {
      const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "."];
      if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) return;

      const isDigit = /^\d$/.test(event.key);
      if (!isDigit) {
        event.preventDefault();
        return;
      }

      // запрещаем вторую точку
      const hasDot = String(this.internalValue).includes(".");
      if (event.key === "." && hasDot) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.remove-top-spacing {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>
